import React from "react";
// import Button from "../../components/ui/Button";
import Modal from "../../components/ui/Modal";
import { validateOtp } from "../../services/remitter";

const MobileVerification = () => {
  const queryParameters = new URLSearchParams(window.location.search);
  const mobileNumber = queryParameters.get("m");
  const otp = queryParameters.get("o");
  const idUser = queryParameters.get("v");
  const sourceVendor = queryParameters.get("p");

  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [displayMessage, setDisplayMessage] = React.useState("");

  React.useEffect(() => {
    if (mobileNumber && otp) {
      validateOtp({
        email_phone: mobileNumber,
        otp: otp,
        otpType: "link",
        id_user: idUser,
        sourceVendor: sourceVendor,
      })
        .then((res) => {
          setIsModalOpen(true);
          if (res?.data?.status)
            setDisplayMessage("Successfully verified, You can close this tab now.");
          else setDisplayMessage(res?.data?.message);
        })
        .catch((error) => {
          setIsModalOpen(true);
          setDisplayMessage(error?.response?.data?.error.type || "Something went wrong");
        });
    }
  }, []);

  return (
    <div>
      <Modal
        animation={true}
        visible={isModalOpen}
        closeHandler={() => setIsModalOpen(false)}
        header="Link Verification"
        modalClass="rounded-md pt-1 pb-4"
        headerClass="text-xl p-0 mb-4 text-blue-900 space-x-6"
        animationClass={{
          beforeAnimation: "md:bottom-0",
          afterAnimation: "md:bottom-2/4 bottom-2/4",
        }}
      >
        <div>{displayMessage}</div>
        {/* <Button></Button> */}
      </Modal>
    </div>
  );
};

export default MobileVerification;
